import { RootState } from "@/store/store";
import { explainWithAiCurrentBillingDataSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAiCurrentBillingDataSelector";

export const explainWithAIFormattedCurrentBillingDataSelector = (
  state: RootState,
) => {
  const currentData = explainWithAiCurrentBillingDataSelector(state);

  if (
    !currentData ||
    !currentData.payload?.group_by ||
    !currentData.payload?.trend_type ||
    !currentData.payload?.dates
  ) {
    return;
  }
  return {
    grouping: currentData.payload?.group_by,
    trendType: currentData.payload?.trend_type,
    dates: currentData.payload?.dates,
  };
};
